import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from "react-redux";
import {sortBy, map} from 'lodash';
import classNames from "classnames";
import AjaxButton from "../../../form/ajax_button";
import axios from "axios";
import moment from "moment";

// import 'react-dates/initialize';
// import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
// import 'react-dates/lib/css/_datepicker.css';

import GeneralStats from './tracking/general_stats'
import HotspotClicks from './tracking/hotspot_clicks'
import CountryList from './tracking/country_list'
import VisitorOccupations from './tracking/visitor_occupations'
import VisitorInterests from  './tracking/visitor_interests'
import VisitorExpertises from './tracking/visitor_expertises'

const Spinner = () => {
  return <div className="row h-100 w-100 d-flex justify-content-center align-items-center" style={{height: "100vh"}}>
    <div className="col text-center">
      <i className="fa fa-circle-notch fa-spin fa-5x"></i>
    </div>
  </div>
}

export default function Tracking() {

  const trackingsUrl = useSelector(state => state.trackingsUrl)
  const [trackings, setTrackings] = useState(null)
  const dispatch = useDispatch()
  const [chosenStartDate, setChosenStartDate] = useState(moment("2022-10-01"));
  const [chosenEndDate, setChosenEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null); 
  
  const onChange = ({startDate, endDate}) => {
    setChosenStartDate(startDate);
    setChosenEndDate(endDate);
    
    setTrackings(null)
    console.log({chosenStartDate, chosenEndDate})
  }

  useEffect(() => {
    axios.get(trackingsUrl, { params: { start_date: chosenStartDate, end_date: chosenEndDate } }).then(response => {
      if (response.data.status == "OK") {
        console.log(response.data.trackings)
        setTrackings(response.data.trackings)
      } else {
        console.error(response)
      }
    })
  }, [chosenStartDate, chosenEndDate])

  const globeStats = trackings?.tag_owner_globe

  return <div>
    <div className="alert alert-danger" role="alert">
      OUTDATE
    </div>
  </div>

  // return <div>
  //   <div className="row mt-4">
  //     <div className="col text-right">
  //       <div className="mr-4 pr-4">
  //         <DateRangePicker
  //           startDate={chosenStartDate} // momentPropTypes.momentObj or null,
  //           startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
  //           minDate={moment("2022-10-01")}
  //           maxDate={moment("2023-10-01")}
  //           enableOutsideDays={true}
  //           isOutsideRange={() => { return false } }
  //           endDate={chosenEndDate} // momentPropTypes.momentObj or null,
  //           endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
  //           onDatesChange={onChange} // PropTypes.func.isRequired,
  //           focusedInput={focusedInput}
  //           onFocusChange={focusedInput => setFocusedInput(focusedInput)}
  //         />
  //     </div>
  //   </div>
  // </div>
  // {!trackings ?
  //   <Spinner/>
  //   :
  //   <div className="row m-4">
  //     <div className="col-md-4">
  //       <div className="shadow m-2 p-3 mb-4">
  //         <GeneralStats trackings={trackings}/>
  //       </div>
  //         {trackings.hotspots &&
  //         <div className="shadow m-2 p-3">
  //           <HotspotClicks trackings={trackings}/>
  //         </div>
  //         }
  //     </div>
  //     <div className="col-md-4">
  //       {trackings.visitor_occupations &&
  //         <div className="shadow m-2 p-3 mb-4">
  //           <VisitorOccupations trackings={trackings}/>
  //         </div>
  //       }
  //       {trackings.visitor_interests &&
  //         <div className="shadow m-2 p-3 mb-4">
  //           <VisitorInterests trackings={trackings}/>
  //         </div>
  //       }
  //       {trackings.visitor_expertises &&
  //         <div className="shadow m-2 p-3 mb-4">
  //           <VisitorExpertises trackings={trackings}/>
  //         </div>
  //       }
  //     </div>
  //     <div className="col-md-4">
  //       <div className="shadow m-2 p-3">
  //         {globeStats &&
  //         <CountryList globeStats={globeStats}/>
  //         }
  //       </div>
  //     </div>
  //   </div>
  // }
  // </div>
}

